import { API_ERROR_MESSAGE, NO_RESULTS_FOUND } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds, ReportTypes } from '../apiConstants'
import { makeApiCall } from '../APIService'

interface HandleXpertDirectorLoadReportProps {
  idNumber: string
  xpertDirector: {
    enquiryID?: string
    enquiryResultID?: string
  } | null
  reference: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setReportId: (value: string) => void
  reportTypeId: number
  downloadReport: (reportId?: string) => void
}

export const handleXpertDirectorLoadReport = ({
  idNumber,
  xpertDirector,
  reference,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setReportId,
  reportTypeId,
  downloadReport,
}: HandleXpertDirectorLoadReportProps): void => {
  const API_URL = `${getAPIUrl()}/DirectorEnquiry/load-report`
  const body = {
    identityNumber: idNumber,
    enquiryId: xpertDirector?.enquiryID,
    enquiryResultId: xpertDirector?.enquiryResultID,
    productId: ProductIds.DirectorEnquiry.productId,
    reference,
    reportType: reportTypeId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: { reportId: string } }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(error?.response?.data?.message || API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}

interface DownloadReportProps {
  reportId: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  reportTypeId: number
}

export const downloadReport = (props: DownloadReportProps): void => {
  const {
    reportId,
    reportTypeId,
    setShowProgress,
    setIsError,
    setErrorMessage,
  } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  fetch(`${getAPIUrl()}/DirectorEnquiry/download-report`, requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'cipcbusinessreport.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}

interface SearchDirectorProps {
  idNumber: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setXpertDirectors: (data: any) => void
}

export const searchDirector = ({
  idNumber,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setXpertDirectors,
}: SearchDirectorProps): void => {
  const API_URL: string = getAPIUrl() + '/DirectorEnquiry/search-director'
  const body: Record<string, string> = {
    identityNumber: idNumber,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response) => {
      if (response.data.length === 0) {
        setShowProgress(false)
        alert(`No results found for: ${idNumber}`)
        setErrorMessage(NO_RESULTS_FOUND)
      } else {
        setShowProgress(false)
        setXpertDirectors(response.data)
      }
    },
    (error: Error) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}
